export enum RemissionStatus {    
    CurrentOrLessThan1Year = 0,
    MoreThanOneYear = 1,
    MoreThanTwoYears = 2,
    MoreThanThreeYears = 3,
    MoreThanFourYears = 4,
    MoreThanFiveYears = 5,
    MoreThanSixYears = 6,
    MoreThanSevenYears = 7,
    MoreThanEightYears = 8,
    MoreThanNineYears = 9,
    MoreThanTenYears = 10,
    MoreThanElevenYears = 11,
    MoreThanTwelveYears = 12,
    MoreThanThirteenYears = 13,
    MoreThanFourteenYears = 14,
    MoreThanFifteenYears = 15
}